module.exports = __webpack_public_path__ + "static/media/nbfc.446e129c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbfc.webp
// module id = 337
// module chunks = 0